import React from 'react'
import RModal from 'react-modal'
import { ReactComponent as Cross } from '../assets/icons/cross.svg'
import styled from '@emotion/styled/macro'
import { useMediaQuery } from 'react-responsive'
const CrossIcon = styled(Cross)`
    cursor: pointer;
    position: absolute;
    width: 2rem;
    height: 2rem;
    right: 0.25rem;
`
export const ModalTitle = styled('div')`
    background-color: var(--colors-primary-accent);
    border-bottom: var(--borders-main);
    margin-bottom: 1.5rem;
    h4 {
        margin: 0;
        padding: 1rem 0.5rem;
    }
`
export const ModalBody = styled('div')`
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    padding: 0.5rem;
    ${({ backgroundColor = 'transparent' }) =>
        'background-color:' + backgroundColor};
`
export const ModalFlexContainer = styled('div')`
    display: flex;
    height: 100%;
    overflow: hidden;
    flex-direction: column;
    box-sizing: border-box;
`
const Modal = ({
    children,
    closeModal,
    overlayStyles,
    contentStyles,
    noPadding,
    ...props
}) => {
    const isMobile = useMediaQuery({ query: '(max-width: 900px)' })
    return (
        <RModal
            ariaHideApp={false}
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(55, 55, 55, 0.75)',
                    ...overlayStyles,
                },
                content: {
                    inset: 'initial',
                    maxWidth: '100vw',
                    width: isMobile ? '100vw' : '30rem',
                    ...(isMobile && { height: '100vh' }),
                    boxSizing: 'border-box',
                    maxHeight: isMobile ? '100vh' : '80vh',
                    border: 'var(--borders-main)',
                    background: '#fff',
                    overflow: 'initial',
                    WebkitOverflowScrolling: 'touch',
                    borderRadius: isMobile ? '0' : 'var(--borderRadius-xl)',
                    boxShadow: 'var(--boxShadow-accent10)',
                    padding: noPadding ? '0' : '0.25rem 1rem',
                    justifyContent: 'center',
                    minHeight: '30rem',
                    overflow: 'auto',
                    ...contentStyles,
                },
            }}
            {...props}
        >
            <>
                {closeModal && <CrossIcon onClick={closeModal} />}
                {children}
            </>
        </RModal>
    )
}

export default Modal
